import type { OperatorLoginResponse } from "@/services/WarrantyApiService/types"
import WarrantyApiService from "@/services/WarrantyApiService/WarrantyApiService"

export async function loginOperator(
  accessKey: string
): Promise<OperatorLoginResponse | Error> {
  const response = await WarrantyApiService.operatorLogin(
    { accessKey }
  )

  if (response.isWrong()) {
    throw new Error(response.value.name)
  }

  return {
    jwtToken: response.value.jwtToken,
    expiresOn: response.value.expiresOn
  }
}